export default {
      id: "thermometer-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#thermometer",
      toString: function () {
        return this.url;
      }
    }